import React, { ChangeEvent, KeyboardEvent, useCallback, useEffect, useState } from "react";
import { css, styled } from "styled-components";

import { Common } from "../styles/Common";
import warning from "../assets/warning.svg";
import missgoUnifiedLogo from "../assets/missgoUnifiedLogo.png";

import { AUTH_SERVICE_TYPE, USER_AUTH_ACTION_TYPE as USER_AUTH_ACTION } from "../types/authType";
import LoginOrSignupViaSMS from "../components/login/LoginOrSignupViaSMS";

interface Props {
    onChangeAction: (type: USER_AUTH_ACTION) => void;
    onChangeAuthService: (val: AUTH_SERVICE_TYPE) => void;
}

const LoginBox: React.FC<Props> = () => {
    const [errorMessage, setErrorMessage] = useState<string>("");

    return (
        <ContainerStyle>
            <WelcomeMessageWrapper>
                <img className="logo" alt="미스고 통합 로고" src={missgoUnifiedLogo} width={80} height={36} />
                <div className="mainText">미스고</div>
                <div className="highlightText">간편 로그인</div>
                <div className="subText">8초면 충분해요!</div>
            </WelcomeMessageWrapper>
            <LoginOrSignupViaSMS />
            {errorMessage && <ErrorMessageBoxStyle className={errorMessage ? "red" : ""}>{errorMessage}</ErrorMessageBoxStyle>}
            <WarningContainer>
                <img className="warning" alt="경고아이콘" src={warning} width={18} height={18} />
                <WarningWord>
                    <div className="Text">미스고가 처음이라면?</div>
                    <div className="Text">문자인증 후 회원가입으로 이동해요.</div>
                </WarningWord>
            </WarningContainer>
        </ContainerStyle>
    );
};

export default LoginBox;

const ContainerStyle = styled.div`
    position: fixed;
    max-height: 85vh;
    transition: all 200ms;
    z-index: 202;
    top: 38%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #ffffff;
    border-radius: 14px;
    width: 100%;
    padding: 24px;

    .loginText {
        font-size: 14px;
        font-weight: 500;
        color: ${Common.colors.normalTextColor};
        margin-top: 20px;
        margin-bottom: 16px;
    }

    @media screen and (max-width: 768px) {
        margin-top: 8px;
    }
`;

const WelcomeMessageWrapper = styled.div`
    text-align: left;
    color: #000000;
    margin-top: 120px;

    .mainText {
        font-size: 26px;
        font-weight: 800;
        line-height: 1.4;
        margin-top: 12px;
    }

    .highlightText {
        font-size: 26px;
        font-weight: 800;
        display: inline-block;
        margin-bottom: 8px;
    }

    .subText {
        color: #6e6e6e;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
        margin-bottom: 40px;
    }
`;

const TitleStyle = styled.p`
    margin: 4px 0px 0px 0px;
    font-weight: 700;
    font-size: 24px;
    line-height: 30px;
    color: ${Common.colors.normalTextColor};

    .loginNotice {
        color: #9da6b3;
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
        margin-top: 8px;
        margin-bottom: 58px;
    }
    @media screen and (max-width: 768px) {
        font-size: 20px;
        padding: 0;
        display: flex;
        gap: 12px;
        width: 100%;
        justify-content: flex-start;
        align-items: flex-start;
        position: relative;
        margin-top: 4px;
        .loginNotice {
            margin-top: 0;
            margin-bottom: 60px;
        }
    }
`;

const ErrorMessageBoxStyle = styled.p`
    padding: 14px 0 20px;
    color: #ffffff;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;

    &.red {
        color: #ff0000;
    }
`;

const WarningContainer = styled.div`
    display: flex;
    gap: 8px;
`;

const WarningWord = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    color: #b1aeb8;
    gap: 8px;

    .mainText {
        font-size: 13px;
        font-weight: 400;
        line-height: 140%;
    }
`;
